var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{attrs:{"autocomplete":"new-password"},on:{"submit":function($event){$event.preventDefault();return _vm.$emit('submit')},"keyup":function($event){return _vm.$emit('keyup')}}},[(_vm.loading)?_c('Spinner'):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }